import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SingleCard } from './layouts';
import { LoginForm, Error500 } from './components';
import { formatMessage } from 'devextreme/localization';
import { useAppSelector, useAppDispatch } from './contexts/hooks';
import { LoadIndicator, Button } from 'devextreme-react';

export default function UnauthenticatedContent() {
  const cnfIn = useAppSelector((config) => config.configuration);
  const dispatch = useAppDispatch();
  const [showError, setShowError] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [retryAttempts, setRetryAttempts] = useState(0);

  const handleRetry = () => {
    setShowError(false);
    setInitialLoadComplete(false);
    setRetryAttempts((prev) => prev + 1);
    // Aquí deberías disparar la acción para recargar la configuración
    // Ejemplo: dispatch(loadConfiguration());
    // Si no tienes la acción disponible, como alternativa:
    window.location.reload();
  };

  useEffect(() => {
    // Timer para considerar que la carga inicial ha completado (timeout)
    const loadTimer = setTimeout(() => {
      setInitialLoadComplete(true);
      // Si después del timeout aún hay error, mostrarlo
      if (cnfIn.Error && !cnfIn.Loading) {
        setShowError(true);
      }
    }, 8000); // Aumentado a 8 segundos para dar más tiempo

    // Si la configuración se carga exitosamente, marcar como completo inmediatamente
    if (cnfIn.Data && !cnfIn.Loading && !cnfIn.Error) {
      setInitialLoadComplete(true);
      setShowError(false);
      clearTimeout(loadTimer);
    }

    // Solo mostrar error después de la carga inicial Y si realmente hay error persistente
    if (cnfIn.Error && initialLoadComplete && !cnfIn.Loading) {
      setShowError(true);
    } else if (!cnfIn.Error && initialLoadComplete) {
      setShowError(false);
    }

    return () => clearTimeout(loadTimer);
  }, [cnfIn, initialLoadComplete, retryAttempts]);

  // Mostrar loading mientras no se complete la carga inicial (exitosa o con error)
  if (!initialLoadComplete || (cnfIn.Loading && !showError)) {
    return (
      <Routes>
        <Route
          path='/login'
          element={
            <SingleCard title="Iniciando sistema..." description="Cargando configuración del sistema, por favor espere...">
              <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
                <LoadIndicator visible={true} />
              </div>
            </SingleCard>
          }
        />
        <Route path='*' element={<Navigate to={'/login'} />}></Route>
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path='/login'
        element={
          <React.Fragment>
            {showError ? (
              <SingleCard>
                <Error500 
                  title={'Error de Conectividad'} 
                  description1={'No se pudo conectar con el servidor. Por favor, verifique su conexión a internet e intente nuevamente.'} 
                />
                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '1.5rem' }}>
                  <Button
                    text="Reintentar"
                    type="default"
                    stylingMode="contained"
                    icon="refresh"
                    onClick={handleRetry}
                  />
                  <Button
                    text="Recargar página"
                    type="normal"
                    stylingMode="outlined"
                    icon="refresh"
                    onClick={() => window.location.reload()}
                  />
                </div>
              </SingleCard>
            ) : (
              <SingleCard title={formatMessage('TitleLogin')} description={formatMessage('DetailLogin')}>
                <LoginForm />
              </SingleCard>
            )}
          </React.Fragment>
        }
      />
      <Route
        path='/error500'
        element={
          <SingleCard>
            <Error500 title={'Error 500'} description1={formatMessage('Error50Description')} />
          </SingleCard>
        }
      />
      <Route path='*' element={<Navigate to={'/login'} />}></Route>
    </Routes>
  );
}
